import React, { useContext, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import RDFFundList from '../RDFFundList/RDFFundList';
import Loader from '../Loader/Loader';
import { FlowContext, DEFAULT_LOADING_MESSAGE } from '../../core/flow-engine';
import { ALL_FUNDS_QUERY } from './queries';
import { sortRetirementMutualFunds } from './util';
import { RewardsContext } from '../../context/RewardsContext/RewardsContext';
import { getRewardsAvailable } from '../../flows/shared/summit.utils';

const RDFFragment = () => {
  const { loading, error, data: { allMutualFunds } = {} } = useQuery(
    ALL_FUNDS_QUERY
  );
  const { appState, next } = useContext(FlowContext);
  const { currentTier = 0 } = useContext(RewardsContext);
  const [openedQuickViewFund, setOpenedQuickViewFund] = useState({});

  if (loading) return <Loader message={DEFAULT_LOADING_MESSAGE} />;
  if (error) return `Error! ${error}`;

  const rewardsAvailable = getRewardsAvailable(
    appState?.store?.accountType,
    appState?.store?.app?.trust,
    appState?.store?.app?.trustee,
    currentTier
  );
  const sortedFunds = sortRetirementMutualFunds(
    allMutualFunds,
    rewardsAvailable,
    appState?.store?.amount
  );

  return (
    <RDFFundList
      sortedFunds={sortedFunds}
      setOpenedQuickViewFund={setOpenedQuickViewFund}
      openedQuickViewFund={openedQuickViewFund}
      next={next}
    />
  );
};

export default RDFFragment;
